module.exports = __webpack_public_path__ + "img/icon_normal.1c993efc.png";